import type { PolicyAndUrgencyCustomControlData } from './FundusscreeningPolicyAndUrgencyAddEditFields';
import { Policies } from '../../../../../../common/validation/customControls/ophthalmology';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function FundusscreeningPolicyAndUrgencyReadFields(props: {
    customControlData: PolicyAndUrgencyCustomControlData;
}) {
    return (
        <>
            {props.customControlData.geadviseerd_beleid &&
                props.customControlData.geadviseerd_beleid !== Policies.anders && (
                    <HorizontalFormGroupRead>
                        <FormLabel>Geadviseerd beleid</FormLabel>
                        <InputContainer>
                            <FormParagraph>{props.customControlData.geadviseerd_beleid}</FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            {props.customControlData.geadviseerd_beleid_anders && (
                <HorizontalFormGroupRead>
                    <FormLabel>Geadviseerd beleid</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.geadviseerd_beleid_anders}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.urgentie && (
                <HorizontalFormGroupRead>
                    <FormLabel>Urgentie</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.urgentie}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
